<template>
</template>

<script>
import StreetViewControl from '@/libraries/ol/StreetView/StreetViewControl';
import ButtonControlMixin from '../mixins/ButtonControlMixin';
import { MAP_ACTIONS } from '@config/constants';
import { detectMobile } from "@config/browser";
import GeoJSON from 'ol/format/GeoJSON';
import Point from 'ol/geom/Point';
import {toLonLat } from 'ol/proj';

let sv = null;
const INTERACTIONS = {
        MODIFY: 'modify',
    };
    let vars = {
        interactions: {}
    };
export default {
	mixins: [
		ButtonControlMixin
	],
	props: {
		showInfoNoGoogle: {
			type: Boolean,
			default: true
		},
		defaultReSizePercent: {
			type: Number,
			default: 50
		},
	},
	data() {
		return {
			idPanel: 'streetview',
			className: 'ol-streetview',
			isStreetViewInitialized : false,
			streetviewElementSelector:".gm-style",
			streetviewElement:null,
			mapContainerElement:null,
			dividerElement: null,
			streetViewActiveCls: 'sv-active',
			isMobileCls: 'sv-mobile',
			isResizing:false,
			streetViewCoords:null,
			isMobile:detectMobile()
		}
	},
	computed:{
		layerSource() {
			return 'streetview';
		},
		configMap() {
			return this.moduleCode ? this.$store.getters.getConfigMap(this.moduleCode) : {};
		},
		layersProperties() {
			return this.configMap.layers.streetview;
		},
		getPanorama(){
			return this.getMap()?.getOLMap()?.panorama || null;
		}
	},
	methods: {
		addButtonMap(_map){
			if(!this.isStreetviewAvailable()){
				if(this.showInfoNoGoogle){
					this.noGoogle();
				}
				return false;
			}

			let panel = _map.getPanel(this.posBtnMap);
			if(panel) {
				let target = panel.element;
				let content = _map.createHtmlBtnImg(this.title, null, this.assetsPathTheme('/map/streetview.svg'));
				let ctrl = new StreetViewControl({
					map: _map.getOLMap(),
					update: true,  // sincronize map position
					className: _map.getControlClassName(this.orderClassName),
					content: content,
					target: target,
					onNoValidLocalion: () => {
						this.onNoValidLocalion();
					},
					onBeforeOpen: () => {
						this.onBeforeOpen();
					},
					onClosed: () => {
						this.onClosed();
					},
					onToggle: (flag, sv) => {
						this.onToggle(flag, sv);
					},
					onPositionChange: (coords, data, status) => {
						this.onPositionChange(coords)
					},
				});
				_map.addControlOL(ctrl);
				this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
					if(sv) sv.forceClose();
					let el = $(ctrl.element); if(el) el.hide()
				});
				this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
					let el = $(ctrl.element); if(el) el.show()
				});
				return ctrl;
			}
			return false;
		},
		setAction(action) {
			this.$store.dispatch(`setActionMap`, {module: this.moduleCode, action});
		},
		isStreetviewAvailable() {
			return (typeof google === 'object'
					&& typeof google.maps === 'object'
						&& typeof google.maps.StreetViewService === 'function');
		},
		noGoogle() {
			this.showWarning(this.$t(`${this.idPanel}.info.noGoogleAvailable`), this.title);
		},
		onNoValidLocalion() {
			this.showWarning(this.$t(`${this.idPanel}.info.onValidLocalion`), this.title);
		},
		onPositionChange(coords){
			this.streetViewCoords=coords;
			this.initializeStreetView()
			.then(res => {
				const _map = this.getMap();
				if(_map) {
					let geom = {geom: (new GeoJSON()).writeGeometry(new Point([coords[0], coords[1]]))};
					if(geom) {
						_map.drawTemporaryFeature({
							source: this.layerSource,
							preserveGeometry:true,
							data: {
									geom: geom,
								}
						});
                       this.createModify()
					}
				}
			});
		},
		createModify(){
			const _map = this.getMap();
			const modify = _map.createModify({
				source: _map.getSource(this.layersProperties.source),
				pixelTolerance: 50
        	});
			modify.on("modifystart", function (evt) {});
			modify.on("modifyend", evt => {
				const feature = evt.features.item(0);
				const geometry = feature.getGeometry();
				const coords = geometry.getCoordinates();
				
				const [lng, lat] = toLonLat(
					coords,
					_map.getOLMap().getView().getProjection().getCode()
				);

				const panorama =this.getPanorama;
				panorama?.setPosition({
					lat,
					lng
				});
				
        	});
        	modify.setActive(true);
        	_map.addInteraction(modify);
			vars.interactions[INTERACTIONS.MODIFY] = modify;
		},
		async initializeStreetView(){
			return new Promise((resolve) => {
				if(!this.isStreetViewInitialized) {
					this.streetviewElement = document.querySelector(this.streetviewElementSelector);
					this.streetviewElement.appendChild(this.createDivider());

					this.mapContainerElement = this.getMap().getOLMap().getTargetElement();
					this.mapContainerElement.classList.add(this.streetViewActiveCls);
					if (this.isMobile) {
						let parentMapContainer = this.mapContainerElement.parentNode;
						parentMapContainer.classList.add(this.isMobileCls);
						const maxGmnoprintZindex = Math.max(
							...[...document.querySelectorAll('.gmnoprint')]
								.map(el => parseInt(getComputedStyle(el).zIndex) || 0)
						)
						if(maxGmnoprintZindex>0)this.dividerElement.style.zIndex = maxGmnoprintZindex+1;
						
					}
					this.resizeMaps(this.defaultReSizePercent)
					this.isStreetViewInitialized = true;
				}
				resolve(1);
			});
		},
		destroyStreetView(){
			try {
				this.resizeMaps(100,true);
				this.destroyDivider();
				if(this.mapContainerElement) {
					this.mapContainerElement.classList.remove(this.streetViewActiveCls);
                    let parentMapContainer = this.mapContainerElement.parentNode;
					parentMapContainer.classList.remove(this.isMobileCls);					
				}

				const _map = this.getMap();
				if(_map) {
					_map.clearTemporaryFeature({source: this.layerSource});
					this.removeMapInteraction(INTERACTIONS.MODIFY);
				}
			} catch(error) {
				console.error(error);
			} finally {
				this.isStreetViewInitialized = false;
			}
		},
		onToggle(flag, ctrl) {
			sv = ctrl;
			if(flag){
				this.setAction(MAP_ACTIONS.STREET_VIEW);
				this.addListener();
			}else{
				this.setAction(null);
				this.removeListener();
			}
		},
		onBeforeOpen() {
			this.showMessage(this.$t(`${this.idPanel}.info.onOpen`), this.title);
			this.$eventBus.publish(this.moduleCode, 'map.start-street-view-panorama');
		},
		onClosed() {
			if (document.fullscreenElement) {
				document.exitFullscreen().catch((error) => {
				console.log("Erro ao sair do fullscreen:", error);
				});
			}
			this.destroyStreetView();
			this.clearMessages();
			this.setAction(null);
			this.removeListener();
			this.$eventBus.publish(this.moduleCode, 'map.end-street-view-panorama');
		},
		addListener(){
			document.addEventListener('keydown', this.escapeHandler);
		},
		removeListener(){
			document.removeEventListener('keydown', this.escapeHandler);
		},
		escapeHandler(evt){
			if(evt instanceof KeyboardEvent) {
				if (evt.key === 'Escape') {
					if(sv){
						sv.forceClose();
					}
				}
			}
		},
		createDivider() {
			const div = document.createElement("div");
			div.className = "ol-street-view--divider";

			const span = document.createElement("span");
			div.appendChild(span);

			 this.isResizing = false;

			// guardar handlers
			this._onPointerDown = (e) => {
				this.isResizing = true;
				const cursorType = this.isMobile ? "ns-resize" : "w-resize";
				document.body.style.cursor = cursorType;
				e.preventDefault();
			};

			this._onPointerUp = () => {
				this.isResizing = false;
				document.body.style.cursor = "default";
			};

			this._onPointerMove = (e) => {
				if (!this.isResizing) return;


				const container = document.querySelector(".map-wrapper");
				if (!container) return;

				const rect = container.getBoundingClientRect();

				let percent = this.isMobile
					? (1 - (e.clientY - rect.top) / rect.height) * 100
					: ((e.clientX - rect.left) / rect.width) * 100;

				percent = Math.max(1, Math.min(99, percent));

				this.resizeMaps(percent);
			};

			this.dividerElement = div;

			// adicionar eventos
			this.dividerElement.addEventListener("pointerdown", this._onPointerDown);
			document.addEventListener("pointerup", this._onPointerUp);
			document.addEventListener("pointermove", this._onPointerMove);

			return this.dividerElement;
		},
		destroyDivider() {
			// remover eventos
			if (this.dividerElement) {
				this.dividerElement.removeEventListener("mousedown", this._onPointerDown);
				this.dividerElement.remove();
			}
			document.removeEventListener("pointerup", this._onPointerUp);
			document.removeEventListener("pointermove", this._onPointerMove);
		},
		resizeMapsMobile(val,other,destroy=false) {
			this.streetviewElement.style.height = other + "%";
			this.mapContainerElement.style.height = val + "%";
			if(destroy){
				this.mapContainerElement.style.width = "100%";	
				this.streetviewElement.style.width = "100%";	
			}
		},
		resizeMapsDesktop(val,other,destroy=false) {
			this.streetviewElement.style.width = other + "%";
			this.mapContainerElement.style.width = val + "%";
			if(destroy){
				this.mapContainerElement.style.height = "100%";
				this.streetviewElement.style.height = "100%";
			}
		},
		resizeMaps(val,destroy=false) {
			if (!this.streetviewElement || !this.mapContainerElement) return;
            const other = 100 - val;			
			if (this.isMobile) {
				this.resizeMapsMobile(val, other,destroy);
			} else {
				this.resizeMapsDesktop(val, other,destroy);
			}						
		},
		handleResize() {
			let isMobile = detectMobile()
			if (this.isMobile !== isMobile) this.isMobile = isMobile;
		},
		removeMapInteraction: function(key) {
                const _map = this.getMap();
                if(_map) {
                    let interaction = vars.interactions[key];
                    if(interaction){
						interaction.setActive(false);
                        _map.removeInteraction(interaction);
                    }
                    vars.interactions[key] = null;
                }
        },	
	},
	mounted() {
    	window.addEventListener('resize', this.handleResize);	  
  	},
  	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
  	},
  	watch:{
			//watch apenas funciona com o handle resize, nao funciona com computed isMobile
			isMobile:{
				immediate: false,
				handler(value) {
					if(this.isStreetViewInitialized){
					this.destroyStreetView();
					this.onPositionChange(this.streetViewCoords);
					}
				}
			}
	}
};
</script>

<style lang="scss">
.map-wrapper {
	.gm-style {
		border-left: 3px solid #222 !important;
		right: 0px;
		left: unset !important;
		z-index: 1032!important;

		.ol-street-view--divider {
			cursor: w-resize;
			background: #222;
			border: 2px solid #000;
			border-radius: 4px;
			box-sizing: border-box;
			display: block;
			height: 50px;
			top: calc(50% - 25px);
			left: -8px;
			padding: 10px 3px;
			position: absolute;
			touch-action: none;
			-webkit-user-select: none;
			-moz-user-select: none;
			user-select: none;
			width: 14px;
			z-index: 99;

			span {
				background-color: #666;
				display: block;
				height: 100%;
				pointer-events: none;
				width: 3px;
			}
		}
	}

	&.sv-mobile {
		.map-default {
			&.sv-active {
				top:unset!important;

				.ol-viewport {
					position: absolute !important;
					top: unset;
					bottom: 0%;
				}
			}
		}

		.gm-style {
			border-bottom: 3px solid #222 !important;
			top: 0px;

			.ol-street-view--divider {
				cursor: ns-resize;

				height: 14px;
				width: 50px;
				top: calc(100% - 6px);
				left: calc(50% - 25px);
				padding: 3px 10px;
				span {
					height: 3px;
					width: 100%;
				}
			}
		}
	}

	.cursor-sv {
		cursor: url("../../../libraries/ol/StreetView/img/street_view_cursor.gif") 7.5 17.5, crosshair;
	}
}

</style>
